import util from '@bmp-vue/core/api/util'

const controller = 'Email'
export default Object.assign({}, util.GetCrud(controller, null))
